__turbopack_context__.v({
  "container": "XClose-module__O72pzG__container",
});
